import BaseTokenProvider from './BaseTokenProvider'
import Info from './Info'
import FormatUtils from '@/utils/FormatUtils'

var InfoTokenProvider = function() {
    BaseTokenProvider.call(this);
};
InfoTokenProvider.prototype = new BaseTokenProvider();

/**
 * @inheritDoc
 */
InfoTokenProvider.prototype.getSupportedTokens = function () {
    return ["info"];
};

InfoTokenProvider.prototype.resolveTextToken = function(mapObject, token, field, defaultValue) {
    if (mapObject != null)
    {
        var info = mapObject.getInfoById(field);
        if (info != null)
        {
            var value = info.value;
            if (info.type === Info.ADDRESS)
            {
                // TODO
            } 
            else if (info.type === Info.DISTANCE)
            {
                var meters = parseFloat(value);
                return FormatUtils.formatDistance(meters);
            } 
            else if (info.type === Info.ELEVATION)
            {
                meters = parseFloat(value);
                return FormatUtils.formatElevation(meters);
            } 
            else if (info.type === Info.WEIGHT)
            {
                var grams = parseFloat(value);
                return FormatUtils.formatWeight(grams);
            }
            else if (info.type === Info.BOOLEAN)
            {
                // TODO
            }
            else if (info.type === Info.DATE)
            {
                // TODO
            }
            else if (info.type === Info.DATE_TIME)
            {
                // TODO
            }
            else if (info.type === Info.TIME)
            {
                // TODO
            }
            else if (info.type === Info.DURATION)
            {
                // TODO
            }
            else if (info.type === Info.ADDRESS)
            {
                // TODO
            }
            else if (info.type === Info.EMAIL)
            {
                // TODO
            }
            return value;
        }
    }
    return defaultValue;
}

export default InfoTokenProvider;